export function getImageUrl(imageUrl) {
    if (imageUrl.startsWith("http")) return imageUrl;
    // old cloudinary images support
    if (imageUrl.includes("/")) {
        imageUrl = imageUrl.split("/")[1];
        imageUrl = imageUrl.replace(/\.[^/.]+$/, "");
    }
    return `https://sl-files.proguscommerce.com/${imageUrl}`;
}

export function getDirectionsUrl(store) {
    return `https://www.google.com/maps/dir/?api=1&destination=${store.lat},${store.lon}`;
}

export function getAddressFormatted(store) {
    return (store.city ? store.city : "") +
        " " +
        (store.province ? store.province : "") +
        " " +
        (store.zipCode ? store.zipCode : "");
}

export function mapTags(locationTags, map) {
    locationTags = locationTags.split(",");
    return locationTags.map(locationTag => map[locationTag]);
}